import FleetCardDetails from "../components/cards/FleetCardDetails";
import PersonalCardDetails from "../components/cards/PersonalCardDetails";

export const cardDetailsComponents = {
  'Client::Card::Fleet': FleetCardDetails,
  'Client::Card::Personal': PersonalCardDetails
}
